/**
 * clipping-util.js
 *
 * Add docs
 *
 */

(function(window, ss, exports) {

  var ClippingUtil = {

    getSlides: function (selector) {
      var $slideImgs = $(selector),
        slidesObj = {};

      $slideImgs.each(function(idx, slide) {
        var $slide = $(slide),
          slideNumber = idx += 1,
          thumbnailUrl = $slide.data('small');

        if (thumbnailUrl) {
          slidesObj[slideNumber] = {
            position: slideNumber,
            thumbUrl: thumbnailUrl,
            isTopClip: false
          };
        }
      });

      return slidesObj;
    },

    /**
     * Fetches the top clipped slides for the current slideshow.
     * @param option.clipCounts {Object} A key value map where key equals slide position,
     *                                   and the value equals global clip count for the slide.
     * @param {Number} numTopClips The number of top clips to return.
     * @returns {Array} top clipped slides in descending order.
     */
    getTopClips: function(clipCounts, numTopClips) {
      var clipsObj = {},
        clipCountsCopy,
        clipsAsArray,
        clipsSorted,
        topClips;

      function sortByDescClipCount(a, b) {
        if (a.clipCount !== b.clipCount) {
          return (b.clipCount - a.clipCount);
        } else {
          return (a.position - b.position);
        }
      }

      if (clipCounts) {
        // Don't include title slide in top clips
        clipCountsCopy = $.extend({}, clipCounts);
        delete clipCountsCopy[1];

        clipsAsArray = ClippingUtil._getClipsAsArray(clipCountsCopy);
        clipsSorted = clipsAsArray.sort(sortByDescClipCount);
        topClips = clipsSorted.slice(0, numTopClips || clipsSorted.length);

        //move to own method?
        $.each(topClips, function(idx, item) {
          topClips[idx].isTopClip = true;
          clipsObj[item.position] = topClips[idx];
        });

        return clipsObj;
      }
    },

    /**
     * Transforms the clip count data embedded on the page into an
     * enumerable friendly array.
     * @param clipCounts {Object} A key value map where key equals slide position,
     *                            and the value equals global clip count for the slide.
     * @returns {Array} all clipped slide data.
     */
    _getClipsAsArray: function (clipCounts) {
      if (clipCounts) {
        return $.map(clipCounts, function (clipCount, position) {
          return {
            position: parseInt(position, 10),
            clipCount: parseInt(clipCount, 10),
            isTopClip: false
          };
        });
      }
    }
  };

  // Export as module
  exports('clippingUtil', {
    getSlides: ClippingUtil.getSlides,
    getTopClips: ClippingUtil.getTopClips
  });

}(window, window.slideshare_object, window.slideshare_object.utils.exports));
